import { jsxs as i, jsx as t, Fragment as b } from "react/jsx-runtime";
import u from "@mui/material/Box";
import { useDefaultLayoutContext as R, DefaultVideoLayout as ue, defaultLayoutIcons as me } from "@vidstack/react/player/layouts/default";
import "@vidstack/react/player/styles/default/theme.css";
import "@vidstack/react/player/styles/default/layouts/video.css";
import { useState as w, useMemo as he, useEffect as F, useRef as M } from "react";
import { useMediaRemote as A, useActiveTextTrack as E, useTextCues as j, useMediaState as f, useCaptionOptions as U, Tooltip as l, CaptionButton as pe, Menu as p, SeekButton as ve, useChapterTitle as te, ChapterTitle as ne, Title as oe, usePlaybackRateOptions as fe, PlayButton as se, PIPButton as ge, MuteButton as xe, VolumeSlider as I, TimeSlider as T } from "@vidstack/react";
import { ClosedCaptionsOnIcon as _, ClosedCaptionsIcon as q, CheckIcon as G, XMarkIcon as be, ShareArrowIcon as Ce, PreviousIcon as Te, NextIcon as Ne, LanguageIcon as Se, OdometerIcon as ye, ReplayIcon as ie, PlayIcon as we, PauseIcon as Ie, PictureInPictureExitIcon as Re, PictureInPictureIcon as Me, MuteIcon as Be, VolumeLowIcon as Ee, VolumeHighIcon as ke, PlaylistIcon as ze } from "@vidstack/react/icons";
import "@mui/material/styles";
import "@mui/material/CssBaseline";
import { I as S, a5 as k } from "./DropdownMultipleSearch-COvERzNg.js";
import { alpha as V } from "@mui/material";
import "@fortawesome/pro-regular-svg-icons";
import "@fortawesome/react-fontawesome";
import "@fortawesome/fontawesome-svg-core";
import "@mui/material/Checkbox";
import "@fortawesome/pro-solid-svg-icons";
import "@fortawesome/pro-light-svg-icons";
import "@mui/material/Stack";
import "@mui/material/Link";
import "@mui/material/Typography";
import "@mui/material/Tooltip";
import L from "@mui/material/Fade";
import "@mui/material/Button";
import "@fortawesome/pro-regular-svg-icons/faXmark";
import "@mui/material/useAutocomplete";
import "@emotion/cache";
import "@emotion/react";
import "@mui/material/Chip";
import "@fortawesome/pro-solid-svg-icons/faCircle";
import "@mui/material/Avatar";
import "@fortawesome/pro-light-svg-icons/faUser";
import "@mui/material/AvatarGroup";
import "@fortawesome/pro-regular-svg-icons/faPlus";
import "@mui/material/LinearProgress";
import "@mui/material/Tabs";
import "@mui/material/Tab";
import "@mui/material/ButtonGroup";
import "@mui/material/Switch";
import "@mui/material/Radio";
import "@mui/material/FormLabel";
import "@mui/material/Autocomplete";
import "@mui/material/FormHelperText";
import "@mui/material/FormControl";
import "@mui/material/OutlinedInput";
import "@mui/material/InputAdornment";
import "@fortawesome/pro-regular-svg-icons/faMagnifyingGlass";
import "@fortawesome/pro-solid-svg-icons/faCheck";
import "@fortawesome/pro-regular-svg-icons/faCircleQuestion";
import H from "@mui/material/Popper";
import Le from "copy-text-to-clipboard";
import { faExpandWide as Oe } from "@fortawesome/pro-solid-svg-icons/faExpandWide";
import { faCompressWide as Fe } from "@fortawesome/pro-solid-svg-icons/faCompressWide";
import { faUpRightAndDownLeftFromCenter as De } from "@fortawesome/pro-solid-svg-icons/faUpRightAndDownLeftFromCenter";
import { faDownLeftAndUpRightToCenter as We } from "@fortawesome/pro-solid-svg-icons/faDownLeftAndUpRightToCenter";
import { faChevronsRight as Ae } from "@fortawesome/pro-solid-svg-icons/faChevronsRight";
import { faChevronsLeft as je } from "@fortawesome/pro-solid-svg-icons/faChevronsLeft";
import { faToggleLargeOn as Ge } from "@fortawesome/pro-solid-svg-icons/faToggleLargeOn";
import { faToggleOff as Ve } from "@fortawesome/pro-solid-svg-icons/faToggleOff";
import { faEye as $e } from "@fortawesome/pro-solid-svg-icons/faEye";
import "react-rnd";
import "react-use";
import "react-hotkeys-hook";
import "@react-spring/web";
import "./AutoScrollContainer-CzyjIY1o.js";
import "@tanstack/react-table";
import "@fortawesome/pro-regular-svg-icons/faArrowRight";
import "@fortawesome/pro-regular-svg-icons/faArrowLeft";
import "@fortawesome/pro-regular-svg-icons/faPenToSquare";
import "@fortawesome/pro-regular-svg-icons/faCircleXmark";
import "@fortawesome/pro-regular-svg-icons/faArrowDown";
import { faArrowUpRightFromSquare as Ue } from "@fortawesome/pro-light-svg-icons/faArrowUpRightFromSquare";
import { faArrowRight as _e } from "@fortawesome/pro-solid-svg-icons/faArrowRight";
import { T as N } from "./Typography-HkIo7ajX.js";
import { s as m } from "./spacings-C27fg6SF.js";
import { r as y } from "./roundings-rAN_HXvA.js";
import { L as re } from "./Logo-agH5zvpp.js";
import { S as ae } from "./ShadowBox-BeNZgJg1.js";
const le = () => {
  const e = A(), n = E("chapters"), s = j(n);
  return {
    ctaGoTo: ({
      isEnabled: r,
      goToType: o,
      goTo: c,
      goToHandler: a
    }) => {
      if (!r)
        return;
      const d = () => {
        var h;
        switch (o) {
          case "goToStep":
            e.seek((h = s[Number(c)]) == null ? void 0 : h.startTime), e.play();
            break;
          case "guiddeLink":
            e.pause(), window.open(String(c), "_self");
            break;
          case "externalLink":
            e.pause(), window.open(String(c), "_blank");
            break;
        }
      };
      if (typeof a == "function") {
        a(d);
        return;
      }
      d();
    }
  };
}, qe = {
  bottomLeft: {
    bottom: "0",
    left: "0"
  },
  bottomRight: {
    bottom: "0",
    right: "0"
  },
  topRight: {
    top: "0",
    right: "0"
  },
  topLeft: {
    top: "0",
    left: "0"
  }
}, He = ({
  isEnabled: e,
  position: n,
  text: s,
  image: r = "",
  goToType: o,
  goTo: c,
  goToHandler: a = void 0,
  onCtaClick: d = () => {
  }
}) => {
  const [h, g] = w(!1), [x, C] = w(!0), { isSmallLayout: v } = R(), ce = he(() => r ? h ? 1 : 0 : 1, [r, h]), { ctaGoTo: de } = le();
  if (!e)
    return null;
  const $ = v ? "topRight" : n, z = $.toLowerCase();
  return /* @__PURE__ */ i(
    ae,
    {
      shadowSize: "md",
      onClick: () => {
        d(), de({ isEnabled: e, goToType: o, goTo: c, goToHandler: a });
      },
      className: "cta cta-single",
      sx: (D) => ({
        display: "flex",
        alignItems: "center",
        position: "absolute",
        zIndex: 11,
        m: m.sm,
        gap: m.sm,
        px: m.sm,
        py: m.xs,
        maxWidth: "max(300px, 40%)",
        backgroundColor: D.palette.common.white,
        color: D.palette.common.black,
        borderRadius: y.xs,
        border: `1px solid ${D.palette.grey[300]}`,
        cursor: "pointer",
        opacity: ce,
        ...qe[$]
      }),
      ...z.includes("bottom") && { "data-vertical-position": "bottom" },
      ...z.includes("top") && { "data-vertical-position": "top" },
      ...z.includes("left") && { "data-horizontal-position": "left" },
      ...z.includes("right") && { "data-horizontal-position": "right" },
      children: [
        !!r && !!x && /* @__PURE__ */ t(u, { sx: { maxWidth: 85, height: 30 }, children: /* @__PURE__ */ t(
          "img",
          {
            src: r,
            alt: "cta-picture",
            style: { objectFit: "cover", width: "100%", height: "100%" },
            onLoad: () => {
              g(!0), C(!0);
            },
            onError: () => {
              g(!0), C(!1);
            }
          }
        ) }),
        /* @__PURE__ */ t(N, { variant: "text", children: s })
      ]
    }
  );
}, Ye = ({ title: e = "", actions: n, onCtaClick: s = () => {
} }) => {
  const r = f("playing"), { isSmallLayout: o } = R(), c = A();
  F(() => {
    c.pause();
  }, []);
  const { ctaGoTo: a } = le();
  return r ? null : /* @__PURE__ */ t(
    u,
    {
      className: "cta cta-multiple",
      sx: (d) => ({
        position: "absolute",
        inset: 0,
        zIndex: 11,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: V(d.palette.common.black, 0.5),
        border: `1px solid ${d.palette.grey[300]}`,
        backdropFilter: "blur(4px)"
      }),
      children: /* @__PURE__ */ i(
        u,
        {
          sx: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            textAlign: "center",
            borderRadius: y.md,
            p: m.xl,
            gap: m.xl
          },
          children: [
            !!e && /* @__PURE__ */ t(
              N,
              {
                variant: "text",
                size: "xl",
                fontWeight: "semibold",
                color: "white",
                children: e
              }
            ),
            /* @__PURE__ */ i(
              u,
              {
                sx: {
                  display: "flex",
                  flexDirection: "column",
                  ...o && {
                    height: "80%"
                  }
                },
                children: [
                  /* @__PURE__ */ t(
                    u,
                    {
                      sx: {
                        display: "flex",
                        justifyContent: "center",
                        flexWrap: "wrap",
                        gap: m.lg,
                        ...o && {
                          overflow: "auto",
                          margin: "auto"
                        }
                      },
                      children: n.map((d, h) => d.isEnabled ? /* @__PURE__ */ i(
                        ae,
                        {
                          shadowSize: "sm",
                          onClick: () => {
                            s(), a({
                              isEnabled: d.isEnabled,
                              goToType: d.goToType,
                              goTo: d.goTo,
                              goToHandler: d.goToHandler
                            });
                          },
                          sx: (g) => ({
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            alignSelf: "center",
                            width: "100%",
                            maxWidth: o ? "160px" : "260px",
                            px: o ? m.md : m.xl,
                            py: o ? m.xs : m.md,
                            gap: m.xs,
                            background: g.palette.common.white,
                            color: g.palette.common.black,
                            borderRadius: y.full,
                            cursor: "pointer"
                          }),
                          children: [
                            /* @__PURE__ */ i(u, { sx: { display: "flex", alignItems: "center" }, children: [
                              /* @__PURE__ */ t(u, { sx: { mr: m.md }, children: "•" }),
                              /* @__PURE__ */ t(
                                N,
                                {
                                  variant: "text",
                                  size: o ? "xs" : "sm",
                                  children: d.text
                                }
                              )
                            ] }),
                            d.goToType === "externalLink" && /* @__PURE__ */ t(
                              S,
                              {
                                icon: Ue,
                                size: o ? "xs" : "sm"
                              }
                            )
                          ]
                        },
                        h
                      ) : null)
                    }
                  ),
                  /* @__PURE__ */ i(
                    u,
                    {
                      sx: (d) => ({
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: m.md,
                        mt: m.xl,
                        textTransform: "uppercase",
                        color: d.palette.common.white,
                        border: `1px solid ${d.palette.common.white}`,
                        px: o ? m.md : m.xl,
                        py: o ? m.xs : m.md,
                        mx: "auto",
                        borderRadius: y.full,
                        cursor: "pointer"
                      }),
                      onClick: () => {
                        c.play();
                      },
                      children: [
                        /* @__PURE__ */ t(S, { icon: _e }),
                        /* @__PURE__ */ t(
                          N,
                          {
                            variant: "text",
                            fontWeight: "bold",
                            size: o ? "xs" : "md",
                            children: "skip"
                          }
                        )
                      ]
                    }
                  )
                ]
              }
            )
          ]
        }
      )
    }
  );
}, Je = ({ ctas: e, onCtaClick: n = () => {
} }) => {
  const s = f("currentTime"), r = E("chapters"), o = j(r);
  return !e.length || !o.length ? null : e.map((c, a) => {
    var x, C, v;
    const d = () => {
      n(c);
    }, g = ((x = o[c.chapterIndex]) == null ? void 0 : x.endTime) - s;
    switch (c.type) {
      case "single":
        return s > ((C = o[c.chapterIndex]) == null ? void 0 : C.startTime) && s < ((v = o[c.chapterIndex]) == null ? void 0 : v.endTime) ? /* @__PURE__ */ t(
          He,
          {
            ...c.action,
            onCtaClick: d
          },
          a
        ) : null;
      case "multiple":
        return g <= 0.3 && g >= 0 ? /* @__PURE__ */ t(
          Ye,
          {
            ...c,
            onCtaClick: d
          },
          a
        ) : null;
      default:
        return null;
    }
  });
}, Y = ({ onChange: e = () => {
} }) => {
  var a;
  const n = U(), s = ((a = n.selectedTrack) == null ? void 0 : a.label) ?? "Off", r = U({ off: !1 }), o = M(null);
  if (!r.length)
    return null;
  if (r.length === 1)
    return /* @__PURE__ */ i(l.Root, { children: [
      /* @__PURE__ */ t(l.Trigger, { asChild: !0, children: /* @__PURE__ */ i(
        pe,
        {
          className: "vds-button",
          onChange: () => {
            e(s);
          },
          children: [
            /* @__PURE__ */ t(_, { className: "vds-icon vds-icon-on" }),
            /* @__PURE__ */ t(q, { className: "vds-icon vds-icon-off" })
          ]
        }
      ) }),
      /* @__PURE__ */ i(l.Content, { className: "vds-tooltip-content", children: [
        "Captions (",
        s,
        ")"
      ] })
    ] });
  const c = /* @__PURE__ */ t(
    p.Content,
    {
      className: "vds-menu-items",
      placement: "top end",
      children: /* @__PURE__ */ t(
        p.RadioGroup,
        {
          className: "vds-radio-group",
          value: n.selectedValue,
          children: n.map(({ label: d, value: h, select: g }) => /* @__PURE__ */ i(
            p.Radio,
            {
              className: "vds-radio",
              value: h,
              onSelect: () => {
                var x;
                e(d), g(), (x = o.current) == null || x.close();
              },
              children: [
                /* @__PURE__ */ t(G, { className: "vds-icon" }),
                /* @__PURE__ */ t("span", { className: "vds-radio-label", children: d })
              ]
            },
            h
          ))
        }
      )
    }
  );
  return /* @__PURE__ */ i(
    p.Root,
    {
      ref: o,
      className: "vds-menu",
      children: [
        /* @__PURE__ */ i(l.Root, { children: [
          /* @__PURE__ */ t(l.Trigger, { asChild: !0, children: /* @__PURE__ */ t(p.Button, { className: "vds-menu-button vds-button", children: s === "Off" ? /* @__PURE__ */ t(q, {}) : /* @__PURE__ */ t(_, {}) }) }),
          /* @__PURE__ */ i(l.Content, { className: "vds-tooltip-content", children: [
            "Captions (",
            s,
            ")"
          ] })
        ] }),
        c
      ]
    }
  );
}, Ke = ({ onClose: e }) => {
  const n = A();
  return /* @__PURE__ */ i(l.Root, { children: [
    /* @__PURE__ */ t(l.Trigger, { asChild: !0, children: /* @__PURE__ */ t(
      "button",
      {
        type: "button",
        className: "vds-button vds-button-close",
        "aria-label": "Close",
        onClick: () => {
          n.pause(), e();
        },
        children: /* @__PURE__ */ t(be, { className: "vds-icon" })
      }
    ) }),
    /* @__PURE__ */ t(l.Content, { className: "vds-tooltip-content", children: "Close" })
  ] });
}, Xe = async ({
  string: e,
  permittedCallback: n,
  deniedCallback: s
}) => navigator.permissions.query({ name: "clipboard-write" }).then((r) => {
  (r.state === "granted" || r.state === "prompt") && navigator.clipboard.writeText(e).then(() => {
    n == null || n();
  }).catch((o) => {
    console.error("COPY LINK ERROR:", o);
  }), r.state === "denied" && (document.queryCommandSupported("copy") ? (Le(e), setTimeout(() => {
    n == null || n();
  })) : s == null || s());
}).catch(() => {
  s == null || s();
}), B = ({ shareLink: e, onShare: n = () => {
}, onShareSuccess: s = () => {
} }) => {
  const { isSmallLayout: r } = R(), o = M(null), [c, a] = w(!1), [d, h] = w(!1), x = /* @__PURE__ */ t(
    "button",
    {
      ref: o,
      type: "button",
      onClick: () => {
        if (e) {
          if (d) {
            h(!1);
            return;
          }
          n(), Xe({
            string: e,
            permittedCallback: () => {
              a(!0), s();
            },
            deniedCallback: () => {
              h(!0);
            }
          });
        }
      },
      className: "vds-button",
      children: /* @__PURE__ */ t(Ce, {})
    }
  );
  return /* @__PURE__ */ i(b, { children: [
    r ? x : /* @__PURE__ */ i(l.Root, { asChild: !0, children: [
      /* @__PURE__ */ t(l.Trigger, { asChild: !0, children: x }),
      /* @__PURE__ */ t(l.Content, { className: "vds-tooltip-content", children: "Share" })
    ] }),
    /* @__PURE__ */ t(
      H,
      {
        anchorEl: o.current,
        open: c || d,
        placement: "left",
        transition: !0,
        disablePortal: !0,
        children: ({ TransitionProps: C }) => /* @__PURE__ */ t(
          L,
          {
            ...C,
            timeout: {
              enter: 1500,
              exit: 500
            },
            onTransitionEnd: () => {
              c && a(!1);
            },
            children: c || d ? /* @__PURE__ */ t(
              u,
              {
                sx: (v) => ({
                  py: m.xxs,
                  px: m.md,
                  mx: m.sm,
                  borderRadius: y.xxs,
                  background: v.palette.common.white,
                  color: v.palette.common.black,
                  border: "1px solid rgb(0 0 0 / 0.2)",
                  width: "max-content"
                }),
                children: /* @__PURE__ */ i(
                  N,
                  {
                    variant: "text",
                    size: "xs",
                    children: [
                      !!c && "Link copied to clipboard",
                      !!d && "Copy the link manually"
                    ]
                  }
                )
              }
            ) : /* @__PURE__ */ t(u, {})
          }
        )
      }
    ),
    /* @__PURE__ */ t(
      H,
      {
        anchorEl: o.current,
        open: d,
        placement: "bottom-end",
        transition: !0,
        disablePortal: !0,
        children: ({ TransitionProps: C }) => /* @__PURE__ */ t(
          L,
          {
            ...C,
            timeout: {
              enter: 1500,
              exit: 500
            },
            children: /* @__PURE__ */ t(
              u,
              {
                sx: {
                  "& input": {
                    width: "100%",
                    textAlign: "center",
                    background: "transparent",
                    border: "none",
                    wordBreak: "break-word",
                    fontWeight: 600,
                    fontSize: "16px",
                    cursor: "pointer",
                    color: "transparent",
                    textShadow: "0 0 0 #FFF",
                    "&:focus-visible": {
                      outline: "none"
                    }
                  },
                  "& [data-url-share-placeholder]": {
                    height: 0,
                    padding: 0,
                    margin: 0,
                    overflow: "hidden",
                    clip: "rect(0, 0, 0, 0)",
                    whiteSpace: "nowrap"
                  }
                },
                children: /* @__PURE__ */ i(u, { children: [
                  /* @__PURE__ */ t(
                    "input",
                    {
                      ref: (v) => {
                        v == null || v.focus(), v == null || v.select(), v == null || v.setSelectionRange(0, 99999);
                      },
                      defaultValue: e,
                      onClick: () => {
                        window.open(e, "_blank"), h(!1);
                      },
                      type: "text",
                      readOnly: !0,
                      onCopy: () => {
                        h(!1);
                      }
                    }
                  ),
                  /* @__PURE__ */ t(u, { "data-url-share-placeholder": !0, children: e })
                ] })
              }
            )
          }
        )
      }
    )
  ] });
}, J = ({ direction: e, onChange: n = () => {
} }) => {
  const s = f("currentTime"), r = E("chapters"), o = j(r);
  if (!o.length)
    return null;
  const c = o.findIndex((x) => x.startTime <= s && x.endTime > s);
  let a = null, d;
  e === "prev" && c > 0 && (d = c - 1, a = o[d]), e === "next" && c < o.length - 1 && (d = c + 1, a = o[c + 1]);
  const h = a ? a.startTime - s : 0, g = Number.isNaN(Number(a == null ? void 0 : a.text)) ? a == null ? void 0 : a.text : `${a == null ? void 0 : a.text}/${o.length}`;
  return /* @__PURE__ */ i(l.Root, { children: [
    /* @__PURE__ */ t(l.Trigger, { asChild: !0, children: /* @__PURE__ */ t(
      ve,
      {
        className: "vds-button",
        seconds: h,
        disabled: !a,
        ...(a == null ? void 0 : a.text) && { "aria-label": `Jump to '${g}'` },
        onChange: () => {
          n(d, e);
        },
        "data-testid": e === "prev" ? "prev-chapter-button" : "next-chapter-button",
        children: e === "prev" ? /* @__PURE__ */ t(Te, {}) : /* @__PURE__ */ t(Ne, {})
      }
    ) }),
    !!(a != null && a.text) && /* @__PURE__ */ t(l.Content, { className: "vds-tooltip-content", children: g })
  ] });
}, Qe = ({ isEnabled: e, onToggle: n }) => /* @__PURE__ */ i(l.Root, { children: [
  /* @__PURE__ */ t(l.Trigger, { asChild: !0, children: /* @__PURE__ */ t(
    "button",
    {
      type: "button",
      className: "vds-button",
      "aria-label": "Toggle theatre mode",
      onClick: n,
      children: /* @__PURE__ */ t(
        S,
        {
          icon: e ? Fe : Oe,
          className: "vds-icon",
          size: "lg",
          style: { height: "65%" }
        }
      )
    }
  ) }),
  /* @__PURE__ */ t(l.Content, { className: "vds-tooltip-content", children: /* @__PURE__ */ i("span", { children: [
    e ? "Exit" : "Enter",
    " Theatre mode"
  ] }) })
] }), Ze = ({ isMinimized: e, onToggle: n }) => /* @__PURE__ */ i(l.Root, { children: [
  /* @__PURE__ */ t(l.Trigger, { asChild: !0, children: /* @__PURE__ */ t(
    "button",
    {
      type: "button",
      className: "vds-button",
      "aria-label": "Toggle minimized mode",
      onClick: n,
      children: e ? /* @__PURE__ */ t(
        S,
        {
          icon: We,
          className: "vds-icon",
          transform: { rotate: 90 },
          style: { height: "50%" }
        }
      ) : /* @__PURE__ */ t(
        S,
        {
          icon: De,
          className: "vds-icon",
          rotate: 90,
          transform: { rotate: 90 },
          style: { height: "50%" }
        }
      )
    }
  ) }),
  /* @__PURE__ */ t(l.Content, { className: "vds-tooltip-content", children: e ? "Minimize" : "Expand" })
] }), O = ({ direction: e, isDisabled: n = !1 }) => {
  const { prevVideo: s, nextVideo: r } = k(), o = () => {
    n || (e === "prev" ? s() : r());
  };
  return /* @__PURE__ */ i(l.Root, { children: [
    /* @__PURE__ */ t(l.Trigger, { asChild: !0, children: /* @__PURE__ */ t(
      "button",
      {
        type: "button",
        className: "vds-button vds-play-button vds-button-playlist-nav",
        onClick: o,
        disabled: n,
        children: e === "prev" ? /* @__PURE__ */ t(
          S,
          {
            icon: je,
            size: "lg",
            className: "vds-icon",
            style: { height: "40%" }
          }
        ) : /* @__PURE__ */ t(
          S,
          {
            icon: Ae,
            size: "lg",
            className: "vds-icon",
            style: { height: "40%" }
          }
        )
      }
    ) }),
    /* @__PURE__ */ t(l.Content, { className: "vds-tooltip-content", children: e === "prev" ? "Prev Video" : "Next Video" })
  ] });
}, Pe = ({ slot: e = null }) => {
  const n = f("paused"), s = f("ended"), r = f("started");
  return !n || !r || s ? null : /* @__PURE__ */ t(L, { in: !0, children: /* @__PURE__ */ t(
    u,
    {
      sx: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 10
      },
      children: e
    }
  ) });
}, et = ({ src: e }) => /* @__PURE__ */ t(u, { sx: { width: "auto", height: 80, borderRadius: y.sm, overflow: "hidden" }, children: /* @__PURE__ */ t(
  "img",
  {
    src: e,
    alt: "brand logo",
    style: { objectFit: "cover", width: "100%", height: "100%" }
  }
) }), tt = ({ onWatermarkClick: e = () => {
} }) => f("paused") ? /* @__PURE__ */ t(
  u,
  {
    className: "watermark",
    sx: {
      position: "absolute",
      right: 0,
      left: 0,
      display: "flex",
      justifyContent: "center"
    },
    children: /* @__PURE__ */ i(
      u,
      {
        sx: (s) => ({
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: m.xs,
          cursor: "pointer",
          backgroundColor: V(s.palette.common.black, 0.3),
          px: m.sm,
          py: m.xxs,
          borderRadius: y.xl
        }),
        onClick: e,
        children: [
          /* @__PURE__ */ t(
            u,
            {
              sx: {
                fontSize: "9px"
              },
              children: "POWERED BY"
            }
          ),
          " ",
          /* @__PURE__ */ t(
            re,
            {
              type: "full",
              variant: "light",
              width: 45,
              height: 14
            }
          )
        ]
      }
    )
  }
) : null, nt = () => {
  const e = f("started"), n = f("title"), s = E("chapters"), r = te();
  return s && (e || !n) ? /* @__PURE__ */ t(
    ne,
    {
      className: "vds-video-title",
      title: r
    }
  ) : /* @__PURE__ */ t(
    oe,
    {
      className: "vds-video-title",
      title: n
    }
  );
}, ot = () => {
  const e = f("title");
  return /* @__PURE__ */ t(
    oe,
    {
      title: e,
      className: "vds-video-title"
    }
  );
}, st = () => {
  const e = f("started"), n = f("title"), s = E("chapters"), r = te();
  return s && (e || !n) ? /* @__PURE__ */ t(
    ne,
    {
      className: "vds-video-title",
      title: r
    }
  ) : null;
}, it = ({ type: e = "videoOnly" }) => e === "videoOnly" ? /* @__PURE__ */ t(ot, {}) : e === "chapterOnly" ? /* @__PURE__ */ t(st, {}) : /* @__PURE__ */ t(nt, {}), W = ({
  placement: e = "bottom",
  type: n = "videoOnly",
  hasWatermark: s = !1,
  shareLink: r = ""
}) => {
  const { isSmallLayout: o } = R();
  return /* @__PURE__ */ i(
    u,
    {
      sx: {
        display: "flex",
        alignItems: "center",
        width: "100%",
        overflow: "hidden",
        ...!!s && e === "top" && {
          mt: m.sm,
          ml: m.sm
        },
        ...e === "bottom" && !o && {
          "& .vds-video-title:before": {
            content: '"•"',
            display: "inline-block",
            mr: m.sm
          }
        }
      },
      children: [
        !!s && e === "top" && !!r && /* @__PURE__ */ t(
          u,
          {
            onClick: () => {
              window.open(r, "_blank");
            },
            sx: { cursor: "pointer" },
            children: /* @__PURE__ */ t(
              re,
              {
                type: "singleLetter",
                variant: "brand",
                width: o ? 30 : 40,
                height: o ? 30 : 40
              }
            )
          }
        ),
        /* @__PURE__ */ t(
          u,
          {
            sx: {
              flexGrow: 1,
              px: m.md,
              maxWidth: "90%",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              color: "rgba(255 255 255 / 0.64)",
              ...e === "top" && {
                fontSize: o ? "14px" : "18px",
                fontWeight: "bold"
              },
              lineHeight: o ? "16px" : "20px"
            },
            children: /* @__PURE__ */ t(it, { type: n })
          }
        )
      ]
    }
  );
}, K = ({
  translations: e = [],
  activeTranslation: n = void 0,
  onChange: s = () => {
  }
}) => {
  const r = M(null);
  if (!e.length || !n)
    return null;
  const o = /* @__PURE__ */ t(
    p.Content,
    {
      className: "vds-menu-items",
      placement: "top end",
      children: /* @__PURE__ */ t(
        p.RadioGroup,
        {
          className: "vds-radio-group",
          value: n.langCode,
          children: e.map(({ langCode: c, langName: a }) => /* @__PURE__ */ i(
            p.Radio,
            {
              className: "vds-radio",
              value: c,
              onSelect: () => {
                var d;
                s(c), (d = r.current) == null || d.close();
              },
              children: [
                /* @__PURE__ */ t(G, { className: "vds-icon" }),
                /* @__PURE__ */ t("span", { className: "vds-radio-label", children: a })
              ]
            },
            c
          ))
        }
      )
    }
  );
  return /* @__PURE__ */ i(
    p.Root,
    {
      ref: r,
      className: "vds-menu",
      children: [
        /* @__PURE__ */ i(l.Root, { children: [
          /* @__PURE__ */ t(l.Trigger, { asChild: !0, children: /* @__PURE__ */ t(p.Button, { className: "vds-menu-button vds-button", children: /* @__PURE__ */ t(Se, { size: 32 }) }) }),
          /* @__PURE__ */ i(l.Content, { className: "vds-tooltip-content", children: [
            "Translation ",
            n.langName
          ] })
        ] }),
        o
      ]
    }
  );
}, X = () => {
  const e = fe(), n = e.selectedValue === "1" ? "Normal" : `${e.selectedValue}x`, s = M(null);
  if (!f("canSetPlaybackRate"))
    return null;
  const o = /* @__PURE__ */ t(
    p.Content,
    {
      className: "vds-menu-items",
      placement: "top end",
      children: /* @__PURE__ */ t(
        p.RadioGroup,
        {
          className: "vds-radio-group",
          value: e.selectedValue,
          children: e.map(({ label: c, value: a, select: d }) => /* @__PURE__ */ i(
            p.Radio,
            {
              className: "vds-radio",
              value: a,
              onSelect: () => {
                var h;
                d(), (h = s.current) == null || h.close();
              },
              children: [
                /* @__PURE__ */ t(G, { className: "vds-icon" }),
                /* @__PURE__ */ t("span", { className: "vds-radio-label", children: c })
              ]
            },
            a
          ))
        }
      )
    }
  );
  return /* @__PURE__ */ i(
    p.Root,
    {
      ref: s,
      className: "vds-menu",
      children: [
        /* @__PURE__ */ i(l.Root, { children: [
          /* @__PURE__ */ t(l.Trigger, { asChild: !0, children: /* @__PURE__ */ t(p.Button, { className: "vds-menu-button vds-button", children: /* @__PURE__ */ t(ye, {}) }) }),
          /* @__PURE__ */ i(l.Content, { className: "vds-tooltip-content", children: [
            "Speed (",
            n,
            ")"
          ] })
        ] }),
        o
      ]
    }
  );
}, Q = ({ isInCenter: e = !1 }) => {
  const n = f("paused"), s = f("ended");
  return s && e ? null : /* @__PURE__ */ i(l.Root, { children: [
    /* @__PURE__ */ t(l.Trigger, { asChild: !0, children: /* @__PURE__ */ t(se, { className: `vds-button ${e ? "vds-play-button-center" : ""}`, children: s ? /* @__PURE__ */ t(ie, { className: "vds-icon" }) : n ? /* @__PURE__ */ t(we, { className: "vds-icon" }) : /* @__PURE__ */ t(Ie, { className: "vds-icon" }) }) }),
    /* @__PURE__ */ t(l.Content, { className: "vds-tooltip-content", children: s ? "Replay" : n ? "Play" : "Pause" })
  ] });
}, Z = () => {
  const e = f("pictureInPicture"), n = async () => {
    try {
      await document.exitPictureInPicture();
    } catch {
    }
  };
  return F(() => (window.addEventListener("unhandledrejection", (s) => {
    var r, o;
    (o = (r = s.reason) == null ? void 0 : r.message) != null && o.includes("Cannot read properties of null (reading 'pictureInPicture')") && s.preventDefault();
  }), () => {
    n();
  }), []), /* @__PURE__ */ i(l.Root, { children: [
    /* @__PURE__ */ t(l.Trigger, { asChild: !0, children: /* @__PURE__ */ t(ge, { className: "vds-pip-button vds-button", children: e ? /* @__PURE__ */ t(Re, { className: "vds-icon" }) : /* @__PURE__ */ t(Me, { className: "vds-icon" }) }) }),
    /* @__PURE__ */ t(l.Content, { className: "vds-tooltip-content", children: e ? "Exit PiP" : "Enter PiP" })
  ] });
}, rt = (e) => {
  const [n, s] = w(!1);
  return F(() => {
    if (!e)
      return;
    const r = () => {
      s(!0);
    }, o = () => {
      s(!1);
    };
    return e.addEventListener("mouseenter", r), e.addEventListener("mouseleave", o), () => {
      e.removeEventListener("mouseenter", r), e.removeEventListener("mouseleave", o);
    };
  }, [e]), n;
}, at = (e) => {
  const [n, s] = w(!1);
  return F(() => {
    if (!e)
      return;
    const r = () => {
      s(!0);
    }, o = () => {
      s(!1);
    };
    return e.addEventListener("focusin", r), e.addEventListener("focusout", o), () => {
      e.removeEventListener("focusin", r), e.removeEventListener("focusout", o);
    };
  }, [e]), n;
}, lt = (e) => {
  const n = rt(e), s = at(e), r = M(!1);
  return r.current && !n ? !1 : (r.current = n, n || s);
}, ct = () => {
  const e = f("volume"), n = f("muted"), [s, r] = w(null), o = lt(s);
  return /* @__PURE__ */ i(
    "div",
    {
      ref: r,
      className: "vds-volume-custom",
      "data-active": o ? "" : null,
      children: [
        /* @__PURE__ */ i(l.Root, { children: [
          /* @__PURE__ */ t(l.Trigger, { asChild: !0, children: /* @__PURE__ */ t(xe, { className: "vds-button", children: n || e === 0 ? /* @__PURE__ */ t(Be, {}) : e < 0.5 ? /* @__PURE__ */ t(Ee, {}) : /* @__PURE__ */ t(ke, {}) }) }),
          /* @__PURE__ */ t(l.Content, { className: "vds-tooltip-content", children: n ? "Unmute" : "Mute" })
        ] }),
        /* @__PURE__ */ t("div", { className: "vds-volume-popup-custom", children: /* @__PURE__ */ i(
          I.Root,
          {
            orientation: "horizontal",
            className: "vds-volume-slider-custom vds-slider",
            children: [
              /* @__PURE__ */ t(I.Track, { className: "vds-slider-track", children: /* @__PURE__ */ t(I.TrackFill, { className: "vds-slider-track-fill vds-slider-track" }) }),
              /* @__PURE__ */ t(I.Thumb, { className: "vds-slider-thumb" }),
              /* @__PURE__ */ t(
                I.Preview,
                {
                  className: "vds-slider-preview",
                  noClamp: !0,
                  children: /* @__PURE__ */ t(I.Value, { className: "vds-slider-value" })
                }
              )
            ]
          }
        ) })
      ]
    }
  );
}, dt = () => {
  const { thumbnails: e } = R();
  return /* @__PURE__ */ i(T.Root, { className: "vds-time-slider vds-slider", children: [
    /* @__PURE__ */ t(T.Chapters, { className: "vds-slider-chapters", children: (n, s) => n.map((r) => {
      var c;
      const o = Number((c = n[n.length - 1]) == null ? void 0 : c.endTime);
      return /* @__PURE__ */ i(
        u,
        {
          ref: s,
          className: "vds-slider-chapter",
          sx: {
            minWidth: `calc(${((r.endTime - r.startTime) / o * 100).toFixed(2)}% - 2px) !important`,
            maxWidth: `calc(${((r.endTime - r.startTime) / o * 100).toFixed(2)}% - 2px) !important`
          },
          children: [
            /* @__PURE__ */ t(T.Track, { className: "vds-slider-track" }),
            /* @__PURE__ */ t(T.TrackFill, { className: "vds-slider-track-fill vds-slider-track" }),
            /* @__PURE__ */ t(T.Progress, { className: "vds-slider-progress vds-slider-track" })
          ]
        },
        r.startTime
      );
    }) }),
    /* @__PURE__ */ i(T.Preview, { className: "vds-slider-preview", children: [
      !!e && /* @__PURE__ */ t(
        T.Thumbnail.Root,
        {
          src: e,
          className: "vds-slider-thumbnail vds-thumbnail",
          children: /* @__PURE__ */ t(T.Thumbnail.Img, {})
        }
      ),
      /* @__PURE__ */ t(T.ChapterTitle, { className: "vds-slider-chapter-title" }),
      /* @__PURE__ */ t(T.Value, { className: "vds-slider-value" })
    ] }),
    /* @__PURE__ */ t(T.Thumb, { className: "vds-slider-thumb" })
  ] });
}, P = () => {
  const { isAutoplayOn: e, toggleAutoplay: n } = k();
  return /* @__PURE__ */ i(l.Root, { children: [
    /* @__PURE__ */ t(l.Trigger, { asChild: !0, children: /* @__PURE__ */ t(
      "button",
      {
        type: "button",
        className: "vds-button",
        "aria-label": "Toggle playlist autoplay",
        onClick: n,
        children: /* @__PURE__ */ t(
          S,
          {
            icon: e ? Ge : Ve,
            size: "lg",
            className: "vds-icon",
            style: { height: "55%" }
          }
        )
      }
    ) }),
    /* @__PURE__ */ i(l.Content, { className: "vds-tooltip-content", children: [
      "Playlist autoplay (",
      e ? "on" : "off",
      ")"
    ] })
  ] });
}, ut = (e) => {
  const n = new Date(Number(e) * 1e3);
  return new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric"
  }).format(n);
}, ee = () => {
  const { isSmallLayout: e } = R(), n = M(null), { playlist: s, videoIndex: r, goToVideo: o } = k();
  if (!(s != null && s.length))
    return null;
  const c = /* @__PURE__ */ t(
    p.Content,
    {
      className: "vds-menu-items",
      placement: e ? null : "top end",
      children: /* @__PURE__ */ t(
        p.RadioGroup,
        {
          className: "vds-chapters-radio-group vds-radio-group",
          value: String(r),
          children: s.map(({ poster: a, title: d, author: h, createdAt: g, viewsAmount: x }, C) => /* @__PURE__ */ t(
            p.Radio,
            {
              className: "vds-chapter-radio vds-radio",
              value: String(C),
              onSelect: () => {
                var v;
                o(C), (v = n.current) == null || v.close();
              },
              children: /* @__PURE__ */ i(
                u,
                {
                  sx: {
                    display: "flex",
                    alignItems: "center",
                    gap: m.lg,
                    width: "100%"
                  },
                  children: [
                    !!a && /* @__PURE__ */ t(
                      u,
                      {
                        sx: {
                          width: e ? 70 : 120
                        },
                        children: /* @__PURE__ */ t(
                          "img",
                          {
                            src: a,
                            alt: "poster",
                            style: { width: "100%", height: "100%", objectFit: "cover" }
                          }
                        )
                      }
                    ),
                    /* @__PURE__ */ i(
                      u,
                      {
                        sx: {
                          display: "flex",
                          flexDirection: "column",
                          width: "100%",
                          maxWidth: `calc(100% - ${e ? 70 : 120}px)`
                        },
                        children: [
                          /* @__PURE__ */ t(
                            u,
                            {
                              sx: {
                                "& .MuiTypography-root": {
                                  width: "100%",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap"
                                }
                              },
                              children: /* @__PURE__ */ t(N, { variant: "text", children: d })
                            }
                          ),
                          !!h && /* @__PURE__ */ t(
                            N,
                            {
                              variant: "text",
                              size: "sm",
                              children: h
                            }
                          ),
                          /* @__PURE__ */ i(u, { sx: { display: "flex", alignItems: "center", justifyContent: "space-between" }, children: [
                            !!g && /* @__PURE__ */ t(
                              N,
                              {
                                variant: "text",
                                size: "sm",
                                children: ut(g)
                              }
                            ),
                            !!x && /* @__PURE__ */ i(u, { sx: { display: "flex", alignItems: "center", gap: m.xs }, children: [
                              /* @__PURE__ */ t(S, { icon: $e }),
                              /* @__PURE__ */ t(
                                N,
                                {
                                  variant: "text",
                                  size: "sm",
                                  children: x
                                }
                              )
                            ] })
                          ] })
                        ]
                      }
                    )
                  ]
                }
              )
            },
            C
          ))
        }
      )
    }
  );
  return /* @__PURE__ */ i(
    p.Root,
    {
      ref: n,
      className: "vds-menu vds-menu--playlist",
      children: [
        /* @__PURE__ */ i(l.Root, { children: [
          /* @__PURE__ */ t(l.Trigger, { asChild: !0, children: /* @__PURE__ */ t(p.Button, { className: "vds-menu-button vds-button", children: /* @__PURE__ */ t(ze, {}) }) }),
          /* @__PURE__ */ t(l.Content, { className: "vds-tooltip-content", children: "Playlist" })
        ] }),
        e ? /* @__PURE__ */ t(
          p.Portal,
          {
            className: "vds-video-layout light vds-menu-portal--playlist",
            disabled: "fullscreen",
            children: c
          }
        ) : c
      ]
    }
  );
}, mt = () => f("ended") ? /* @__PURE__ */ i(l.Root, { children: [
  /* @__PURE__ */ t(l.Trigger, { asChild: !0, children: /* @__PURE__ */ t(se, { className: "vds-button", children: /* @__PURE__ */ t(ie, {}) }) }),
  /* @__PURE__ */ t(l.Content, { className: "vds-tooltip-content", children: "Replay" })
] }) : null, ht = ({ playerProps: e, shareLink: n = "" }) => {
  const s = f("ended"), { isPlaylist: r } = k();
  return s ? /* @__PURE__ */ t(L, { in: !0, children: /* @__PURE__ */ t(
    u,
    {
      sx: (o) => ({
        position: "absolute",
        inset: 0,
        zIndex: 11,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: V(o.palette.common.black, 0.5),
        backdropFilter: "blur(4px)"
      }),
      children: /* @__PURE__ */ i(
        u,
        {
          sx: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%"
          },
          children: [
            !!(r || e.hasPlaylistControlsOnly) && /* @__PURE__ */ i(b, { children: [
              /* @__PURE__ */ t("div", { className: "vds-controls-spacer" }),
              /* @__PURE__ */ t(
                O,
                {
                  direction: "prev",
                  isDisabled: e.isPlaylistNavDisabled
                }
              ),
              /* @__PURE__ */ t("div", { className: "vds-controls-spacer" })
            ] }),
            /* @__PURE__ */ i(
              u,
              {
                sx: {
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: m["4xl"]
                },
                children: [
                  !!e.hasBranding && !!e.brandLogoSrc && /* @__PURE__ */ t(et, { src: e.brandLogoSrc }),
                  /* @__PURE__ */ i(u, { sx: { display: "flex", alignItems: "center" }, children: [
                    /* @__PURE__ */ t(mt, {}),
                    !!e.hasShareButton && !!n && /* @__PURE__ */ t(
                      B,
                      {
                        shareLink: n,
                        onShare: e.onShare,
                        onShareSuccess: e.onShareSuccess
                      }
                    )
                  ] })
                ]
              }
            ),
            !!(r || e.hasPlaylistControlsOnly) && /* @__PURE__ */ i(b, { children: [
              /* @__PURE__ */ t("div", { className: "vds-controls-spacer" }),
              /* @__PURE__ */ t(
                O,
                {
                  direction: "next",
                  isDisabled: e.isPlaylistNavDisabled
                }
              ),
              /* @__PURE__ */ t("div", { className: "vds-controls-spacer" })
            ] }),
            e.endScreenSlot
          ]
        }
      )
    }
  ) }) : null;
}, jn = ({
  playerProps: e,
  translations: n = [],
  thumbnails: s = [],
  ctas: r = [],
  shareLink: o = ""
}) => {
  const { isPlaylist: c } = k(), a = !!e.hasCloseButton && typeof e.onClose == "function";
  return /* @__PURE__ */ i(
    ue,
    {
      icons: me,
      thumbnails: s,
      colorScheme: "light",
      smallLayoutWhen: ({ width: d, height: h }) => d <= 650 || h < 380,
      slots: {
        timeSlider: /* @__PURE__ */ t(dt, {}),
        ...e.hasCaptions ? {
          captionButton: /* @__PURE__ */ t(Y, { onChange: e.onCaptionsChange })
        } : {
          captions: null,
          captionButton: null
        },
        ...!e.hasFullscreenMode && {
          fullscreenButton: null
        },
        afterFullscreenButton: /* @__PURE__ */ i(b, { children: [
          !!e.hasTheatreMode && typeof e.isTheatreModeEnabled < "u" && typeof e.onTheatreModeToggle == "function" && /* @__PURE__ */ t(
            Qe,
            {
              isEnabled: e.isTheatreModeEnabled,
              onToggle: e.onTheatreModeToggle
            }
          ),
          !!e.hasMinimizedMode && typeof e.isMinimizedModeEnabled < "u" && typeof e.onMinimizedModeToggle == "function" && /* @__PURE__ */ t(
            Ze,
            {
              isMinimized: e.isMinimizedModeEnabled,
              onToggle: e.onMinimizedModeToggle
            }
          )
        ] }),
        ...(c || e.hasPlaylistControlsOnly) && {
          centerControlsGroupStart: /* @__PURE__ */ i(b, { children: [
            /* @__PURE__ */ t("div", { className: "vds-controls-spacer" }),
            /* @__PURE__ */ t(
              O,
              {
                direction: "prev",
                isDisabled: e.isPlaylistNavDisabled
              }
            ),
            /* @__PURE__ */ t("div", { className: "vds-controls-spacer" })
          ] }),
          centerControlsGroupEnd: /* @__PURE__ */ i(b, { children: [
            /* @__PURE__ */ t("div", { className: "vds-controls-spacer" }),
            /* @__PURE__ */ t(
              O,
              {
                direction: "next",
                isDisabled: e.isPlaylistNavDisabled
              }
            ),
            /* @__PURE__ */ t("div", { className: "vds-controls-spacer" })
          ] })
        },
        smallLayout: {
          startDuration: null,
          chapterTitle: null,
          muteButton: null,
          volumeSlider: null,
          captionButton: null,
          topControlsGroupStart: /* @__PURE__ */ i(b, { children: [
            !!e.hasShareButton && !!o && e.shareButtonPosition === "left" && /* @__PURE__ */ t(
              B,
              {
                shareLink: o,
                onShare: e.onShare,
                onShareSuccess: e.onShareSuccess
              }
            ),
            !!e.hasTopTitle && /* @__PURE__ */ t(
              W,
              {
                placement: "top",
                type: e.topTitleType,
                hasWatermark: e.hasWatermark,
                shareLink: o
              }
            )
          ] }),
          beforeFullscreenButton: /* @__PURE__ */ i(b, { children: [
            !!e.hasTranslations && /* @__PURE__ */ t(
              K,
              {
                onChange: e.onTranslationChange,
                translations: n,
                activeTranslation: e.activeTranslation
              }
            ),
            !!e.hasSpeedMenu && /* @__PURE__ */ t(X, {}),
            !!e.hasCaptions && /* @__PURE__ */ t(Y, { onChange: e.onCaptionsChange }),
            !!e.hasPIPMode && /* @__PURE__ */ t(Z, {})
          ] }),
          ...(c || e.hasPlaylistControlsOnly) && {
            afterChapterTitle: !!e.isPlaylistAutoplayBehaviorOn && !!e.hasPlaylistAutoplaySwitcher && /* @__PURE__ */ t(P, {})
          },
          topControlsGroupEnd: /* @__PURE__ */ i(b, { children: [
            !!e.hasShareButton && !!o && e.shareButtonPosition === "right" && /* @__PURE__ */ t(
              B,
              {
                shareLink: o,
                onShare: e.onShare,
                onShareSuccess: e.onShareSuccess
              }
            ),
            !!c && !!e.hasPlaylistMenu && /* @__PURE__ */ t(ee, {}),
            !!a && /* @__PURE__ */ t("div", { className: "space-for-close-btn" })
          ] }),
          beforeCurrentTime: /* @__PURE__ */ i(b, { children: [
            /* @__PURE__ */ t(Q, {}),
            /* @__PURE__ */ t(ct, {})
          ] })
        },
        largeLayout: {
          topControlsGroupStart: (
            // eslint-disable-next-line react/jsx-no-useless-fragment
            /* @__PURE__ */ i(b, { children: [
              !!e.hasShareButton && !!o && e.shareButtonPosition === "left" && /* @__PURE__ */ t(
                B,
                {
                  shareLink: o,
                  onShare: e.onShare,
                  onShareSuccess: e.onShareSuccess
                }
              ),
              !!e.hasTopTitle && /* @__PURE__ */ t(
                W,
                {
                  placement: "top",
                  type: e.topTitleType,
                  hasWatermark: e.hasWatermark,
                  shareLink: o
                }
              )
            ] })
          ),
          centerControlsGroupCenter: /* @__PURE__ */ t(Q, { isInCenter: !0 }),
          chapterTitle: e.hasBottomTitle ? /* @__PURE__ */ t(
            W,
            {
              placement: "bottom",
              type: e.bottomTitleType
            }
          ) : (
            // keeps place at the controls bar when title is disabled
            /* @__PURE__ */ t(u, { flexGrow: 1 })
          ),
          pipButton: e.hasPIPMode ? /* @__PURE__ */ t(Z, {}) : null,
          ...e.hasChapterNav && {
            beforeMuteButton: /* @__PURE__ */ i(b, { children: [
              /* @__PURE__ */ t(
                J,
                {
                  direction: "prev",
                  onChange: e.onChapterNav
                }
              ),
              /* @__PURE__ */ t(
                J,
                {
                  direction: "next",
                  onChange: e.onChapterNav
                }
              )
            ] })
          },
          ...(!!e.hasSpeedMenu || !!e.hasTranslations) && {
            beforeCaptionButton: /* @__PURE__ */ i(b, { children: [
              !!e.hasTranslations && /* @__PURE__ */ t(
                K,
                {
                  onChange: e.onTranslationChange,
                  translations: n,
                  activeTranslation: e.activeTranslation
                }
              ),
              !!e.hasSpeedMenu && /* @__PURE__ */ t(X, {})
            ] })
          },
          topControlsGroupEnd: /* @__PURE__ */ i(b, { children: [
            !!e.hasShareButton && !!o && e.shareButtonPosition === "right" && /* @__PURE__ */ t(
              B,
              {
                shareLink: o,
                onShare: e.onShare,
                onShareSuccess: e.onShareSuccess
              }
            ),
            !!a && /* @__PURE__ */ t("div", { className: "space-for-close-btn" })
          ] }),
          afterChapterTitle: /* @__PURE__ */ i(b, { children: [
            !!(c || e.hasPlaylistControlsOnly) && !!e.isPlaylistAutoplayBehaviorOn && !!e.hasPlaylistAutoplaySwitcher && /* @__PURE__ */ t(P, {}),
            !!c && !!e.hasPlaylistMenu && /* @__PURE__ */ t(ee, {})
          ] })
        },
        // removed because of no use
        chaptersMenu: null,
        settingsMenu: null,
        liveButton: null,
        downloadButton: null,
        airPlayButton: null,
        googleCastButton: null
      },
      children: [
        !!e.hasCTAs && !!r.length && /* @__PURE__ */ t(
          Je,
          {
            ctas: r,
            onCtaClick: e.onCtaClick
          }
        ),
        !!a && /* @__PURE__ */ t("div", { className: "vds-button-close-container", children: /* @__PURE__ */ t(Ke, { onClose: e.onClose }) }),
        !!e.hasWatermark && /* @__PURE__ */ t(tt, { onWatermarkClick: e.onWatermarkClick }),
        !!e.hasPauseScreen && /* @__PURE__ */ t(Pe, { slot: e.pauseScreenSlot }),
        !!e.hasEndScreen && /* @__PURE__ */ t(
          ht,
          {
            playerProps: e,
            shareLink: o
          }
        )
      ]
    }
  );
};
export {
  jn as L
};
